import axios from "axios";
import { saveAs } from 'file-saver';

//Tài khoản
import {
    RegisterFailed, RegisterStart, RegisterSuccess,
    loginFailed, loginStart, loginSuccess,
    logoutFailed, logoutStart, logoutSuccess,
    editUserStart, editUserSuccess, editUserFailed,
    deleteUserStart, deleteUserSuccess, deleteUserFailed,
    getallUserStart, getallUserSuccess, getallUserFailed,
} from "./authSlice";
// Phân loại
import {
    getallcategoryStart, getallcategorySuccess, getallcategoryFailed,
    getcategoryStart, getcategorySuccess, getcategoryFailed
} from "./categories";
//Chuyên đề
import {
    getsubjectStart, getsubjectSuccess, getsubjectFailed,
    createSubjectStart, createSubjectSuccess, createSubjectFailed,
    editSubjectStart, editSubjectSuccess, editSubjectFailed,
    deleteSubjectStart, deleteSubjectSuccess, deleteSubjectFailed,
} from "./subjects";
//Câu hỏi
import {
    deleteQuestionStart, deleteQuestionSuccess, deleteQuestionFailed,
    editQuestionStart, editQuestionSuccess, editQuestionFailed,
    createQuestionStart, createQuestionSuccess, createQuestionFailed,
    getquestionstart, getquestionSuccess, getquestionFailed,
} from "./questions";
//Đề thi
import {
    createExamStart, createExamSuccess, createExamFailed
} from "./exams"

//Phòng ban
import {
    editPositionStart, editPositionSuccess, editPositionFailed,
    createPositionStart, createPositionSuccess, createPositionFailed,
    getPositionStart, getPositionSuccess, getPositionFailed
} from "./positions"

//Chức vụ
import {
    editDepartmentStart, editDepartmentSuccess, editDepartmentFailed,
    createDepartmentStart, createDepartmentSuccess, createDepartmentFailed,
    getDepartmentStart, getDepartmentSuccess, getDepartmentFailed
} from "./departments"

//Đề thi ONLINE
import {
    getExamStart, getExamSuccess, getExamFailed,
    createEmxamOnlineStart, createEmxamOnlineSuccess, createEmxamOnlineFailed,
    getHistoryExamStart, getHistoryExamSuccess, getHistoryExamFailed,
    getNewExamStart, getNewExamSuccess, getNewExamFailed,
    getDoExamStart, getDoExamSuccess, getDoExamFailed,
    submitEmxamOnlineStart, submitEmxamOnlineSuccess, submitEmxamOnlineFailed,
    getExamByIdStart, getExamByIdSuccess, getExamByIdFailed,
} from "./examsonline"

axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL;

//Xóa tài khoản
export const deleteUser = async (id, dispatch, successCallback, errCallback, accessToken, axiosJWT) => {
    await dispatch(deleteUserStart());
    try {
        await axiosJWT.delete(`/api/users/${id}`, {
            headers: { token: `Bearer ${accessToken}` },
        });
        await dispatch(deleteUserSuccess());
        await successCallback();
    }
    catch (error) {
        await errCallback();
        await dispatch(deleteUserFailed(error));
    }
}
//Chỉnh sửa người dùng
export const editUser = async (id, newData, dispatch, successCallback, errCallback, accessToken, axiosJWT) => {
    await dispatch(editUserStart());
    try {
        await axiosJWT.put(`/api/user/${id}`, newData, {
            headers: { token: `Bearer ${accessToken}` },
        });
        await dispatch(editUserSuccess());
        await successCallback();
    }
    catch (error) {
        await errCallback();
        await dispatch(editUserFailed(error));
    }
}

//Đăng nhập
export const loginUser = async (user, dispatch, navigate, errorCallback) => {
    dispatch(loginStart());
    try {
        const res = await axios.post("/api/login", user);
        await dispatch(loginSuccess(res.data));
        await navigate("/");
    }
    catch (error) {
        if (error.response && error.response.data && error.response.data.message !== "") {
            errorCallback(new Error("Sai tên đăng nhập hoặc mật khẩu"));
            dispatch(loginFailed());
        }
    }
}
//Đăng xuất
export const logOut = async (dispatch, id, navigate, accessToken, axiosJWT) => {
    dispatch(logoutStart());
    try {
        await axiosJWT.post("/api/logout", id, {
            headers: { token: `Bearer ${accessToken}` },
        });
        dispatch(logoutSuccess());
        navigate("/login");
    }
    catch (err) {
        dispatch(logoutFailed());
    }
}
//Đăng ký
export const registerUser = async (user, dispatch, successCallback, errCallback, accessToken, axiosJWT) => {
    dispatch(RegisterStart());
    try {
        await axiosJWT.post("/api/register", user, {
            headers: { token: `Bearer ${accessToken}` },
        })
        dispatch(RegisterSuccess());
        await successCallback();
    } catch (error) {
        if (error.response && error.response.data && error.response.data.message !== "") {
            await errCallback();
            dispatch(RegisterFailed(error));
        }
    }
}
//Lấy thông tin các user
export const getAlluser = async (user, dispatch, axiosJWT) => {
    dispatch(getallUserStart());
    try {
        const res = await axiosJWT.get("/api/users/non-admin", {
            headers: { token: `Bearer ${user}` },
        });
        await dispatch(getallUserSuccess(res.data));
    }
    catch (error) {
        if (error.response && error.response.data && error.response.data.message !== "") {
            dispatch(getallUserFailed());
        }
    }
}


//Lấy chuyên đề theo phân loại
export const getAllSubjectByAllCategory = async (accessToken, dispatch, axiosJWT) => {
    dispatch(getallcategoryStart());
    try {
        const res = await axiosJWT.get("/api/category/showall", {
            headers: { token: `Bearer ${accessToken}` },
        });
        await dispatch(getallcategorySuccess(res.data));
    }
    catch (error) {
        if (error.response && error.response.data && error.response.data.message !== "") {
            dispatch(getallcategoryFailed());
        }
    }
}
//Lấy tất cả chuyên đề
export const getSubject = async (user, dispatch, axiosJWT) => {
    dispatch(getsubjectStart());
    try {
        const res = await axiosJWT.get("/api/subject", {
            headers: { token: `Bearer ${user}` },
        });
        await dispatch(getsubjectSuccess(res.data));
    }
    catch (error) {
        if (error.response && error.response.data && error.response.data.message !== "") {
            dispatch(getsubjectFailed());
        }
    }
}
//lấy phân loại chuyên đề
export const getCategory = async (user, dispatch, axiosJWT) => {
    dispatch(getcategoryStart());
    try {
        const res = await axiosJWT.get("/api/category", {
            headers: { token: `Bearer ${user}` },
        });
        await dispatch(getcategorySuccess(res.data));
    }
    catch (error) {
        if (error.response && error.response.data && error.response.data.message !== "") {
            dispatch(getcategoryFailed());
        }
    }
}
//Tạo mới chuyên đề
export const createSubject = async (dispatch, accessToken, newSubject, axiosJWT, successCallback, errCallback) => {
    dispatch(createSubjectStart());
    try {
        await axiosJWT.post("/api/subject", newSubject, {
            headers: { token: `Bearer ${accessToken}` },
        })
        dispatch(createSubjectSuccess());
        await successCallback();
    } catch (error) {
        if (error.response && error.response.data && error.response.data.message !== "") {
            await errCallback();
            // errorCallback(new Error("Username already exists"));
            dispatch(createSubjectFailed(error));
        }
    }
}
//Tạo mới câu hỏi
export const createQuestion = async (dispatch, accessToken, newQuestion, axiosJWT, successCallback, errCallback) => {
    dispatch(createQuestionStart());
    try {
        await axiosJWT.post("/api/question", newQuestion, {
            headers: {
                'Content-Type': 'multipart/form-data',
                token: `Bearer ${accessToken}`
            }
        });
        dispatch(createQuestionSuccess());
        await successCallback();
    } catch (error) {
        if (error.response && error.response.data && error.response.data.message !== "") {
            await errCallback();
            dispatch(createQuestionFailed(error));
        }
    }
};
//Sửa một câu hỏi
export const editQuestion = async (id, dispatch, accessToken, newQuestion, axiosJWT, successCallback, errCallback) => {
    dispatch(editQuestionStart());
    try {
        await axiosJWT.put(`/api/question/${id}`, newQuestion, {
            headers: {
                'Content-Type': 'multipart/form-data',
                token: `Bearer ${accessToken}`
            }
        });
        dispatch(editQuestionSuccess());
        await successCallback();
    } catch (error) {
        if (error.response && error.response.data && error.response.data.message !== "") {
            await errCallback();
            dispatch(editQuestionFailed(error));
        }
    }
};
//Xóa một câu hỏi
export const deleteQuestion = async (id, dispatch, accessToken, axiosJWT, successCallback, errCallback) => {
    dispatch(deleteQuestionStart());
    try {
        await axiosJWT.delete(`/api/question/${id}`, {
            headers: {
                'Content-Type': 'multipart/form-data',
                token: `Bearer ${accessToken}`
            }
        });
        dispatch(deleteQuestionSuccess());
        await successCallback();
    } catch (error) {
        if (error.response && error.response.data && error.response.data.message !== "") {
            await errCallback();
            dispatch(deleteQuestionFailed(error));
        }
    }
};

//Lấy các câu hỏi trong một chuyên đề
export const getQuestionById = async (id, user, dispatch, axiosJWT) => {
    dispatch(getquestionstart());
    try {
        const res = await axiosJWT.get(`/api/question/${id}`, {
            headers: { token: `Bearer ${user}` },
        });
        await dispatch(getquestionSuccess(res.data));
    }
    catch (error) {
        if (error.response && error.response.data && error.response.data.message !== "") {
            dispatch(getquestionFailed());
        }
    }
}
// Tạo đề thi
export const createExam = async (dispatch, accessToken, newExam, axiosJWT, successCallback, errCallback) => {
    dispatch(createExamStart());
    try {
        const response = await axiosJWT.post("/api/create-exam", newExam, {
            headers: { token: `Bearer ${accessToken}` },
            responseType: 'blob',
        });

        dispatch(createExamSuccess());

        const contentDisposition = response.headers['content-disposition'];
        let fileName = 'exam.docx';
        if (contentDisposition) {
            const match = contentDisposition.match(/filename="(.+)"/);
            if (match && match[1]) {
                fileName = match[1];
            }
        }

        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
        saveAs(blob, fileName);

        await successCallback();
    } catch (error) {
        if (error.response && error.response.data && error.response.data.message !== "") {
            await errCallback();
            dispatch(createExamFailed(error));
        }
    }
}
//Chỉnh sửa chuyên đề
export const updateSubject = async (dispatch, accessToken, subject_id, updatedSubject, axiosJWT, successCallback, errCallback) => {
    dispatch(editSubjectStart());
    try {
        const res = await axiosJWT.put(`/api/subject/${subject_id}`, updatedSubject, {
            headers: { token: `Bearer ${accessToken}` },
        });
        await dispatch(editSubjectSuccess(res.data));
        await successCallback();
    }
    catch (error) {
        if (error.response && error.response.data && error.response.data.message !== "") {
            await dispatch(editSubjectFailed());
            await errCallback();
        }
    }
}

//Xóa một chuyên đề
export const deleteSubject = async (id, dispatch, accessToken, axiosJWT, successCallback, errCallback) => {
    dispatch(deleteSubjectStart());
    try {
        await axiosJWT.delete(`/api/subject/${id}`, {
            headers: {
                'Content-Type': 'multipart/form-data',
                token: `Bearer ${accessToken}`
            }
        });
        dispatch(deleteSubjectSuccess());
        await successCallback();
    } catch (error) {
        if (error.response && error.response.data && error.response.data.message !== "") {
            await errCallback();
            dispatch(deleteSubjectFailed(error));
        }
    }
};
//Lấy tất cả chức vụ
export const getDepartment = async (user, dispatch, axiosJWT) => {
    dispatch(getDepartmentStart());
    try {
        const res = await axiosJWT.get("/api/departments", {
            headers: { token: `Bearer ${user}` },
        });
        await dispatch(getDepartmentSuccess(res.data));
    }
    catch (error) {
        if (error.response && error.response.data && error.response.data.message !== "") {
            dispatch(getDepartmentFailed());
        }
    }
}
//Thêm chức vụ
export const createDepartment = async (dispatch, accessToken, newDepartment, axiosJWT, successCallback, errCallback) => {
    dispatch(createDepartmentStart());
    try {
        await axiosJWT.post("/api/departments", newDepartment, {
            headers: { token: `Bearer ${accessToken}` },
        })
        dispatch(createDepartmentSuccess());
        await successCallback();
    } catch (error) {
        if (error.response && error.response.data && error.response.data.message !== "") {
            await errCallback();
            dispatch(createDepartmentFailed(error));
        }
    }
}
//Lấy danh sách phòng ban
export const getPosition = async (user, dispatch, axiosJWT) => {
    dispatch(getPositionStart());
    try {
        const res = await axiosJWT.get("/api/positions", {
            headers: { token: `Bearer ${user}` },
        });
        await dispatch(getPositionSuccess(res.data));
    }
    catch (error) {
        if (error.response && error.response.data && error.response.data.message !== "") {
            dispatch(getPositionFailed());
        }
    }
}
//Thêm phòng ban
export const createPosition = async (dispatch, accessToken, newPosition, axiosJWT, successCallback, errCallback) => {
    dispatch(createPositionStart());
    try {
        await axiosJWT.post("/api/positions", newPosition, {
            headers: { token: `Bearer ${accessToken}` },
        })
        dispatch(createPositionSuccess());
        await successCallback();
    } catch (error) {
        if (error.response && error.response.data && error.response.data.message !== "") {
            await errCallback();
            dispatch(createPositionFailed(error));
        }
    }
}

// Lấy thông tin đề thi online
export const getAllExamOnline = async (user, dispatch, axiosJWT) => {
    dispatch(getExamStart());
    try {
        const res = await axiosJWT.get("/api/exam-assignments", {
            headers: { token: `Bearer ${user}` },
        });
        await dispatch(getExamSuccess(res.data));
    }
    catch (error) {
        if (error.response && error.response.data && error.response.data.message !== "") {
            dispatch(getExamFailed());
        }
    }
}
// Lấy thông tin các đề thi mới của một user
export const getNewExamUser = async (user, dispatch, axiosJWT, id) => {
    dispatch(getNewExamStart());
    try {
        const res = await axiosJWT.get(`/api/exam-assignments/read/${id}?status=incomplete`, {
            headers: { token: `Bearer ${user}` },
        });
        await dispatch(getNewExamSuccess(res.data));
    }
    catch (error) {
        if (error.response && error.response.data && error.response.data.message !== "") {
            dispatch(getNewExamFailed());
        }
    }
}
// Lấy thông tin các đề thi đã hoàn thành của một user 
export const getHisExamUser = async (user, dispatch, axiosJWT, id) => {
    dispatch(getHistoryExamStart());
    try {
        const res = await axiosJWT.get(`/api/exam-assignments/read/${id}?status=completed`, {
            headers: { token: `Bearer ${user}` },
        });
        await dispatch(getHistoryExamSuccess(res.data));
    }
    catch (error) {
        if (error.response && error.response.data && error.response.data.message !== "") {
            dispatch(getHistoryExamFailed());
        }
    }
}
// Lấy thông tin đề thi user chưa hoàn thành để user tham gia thi 
export const getDoExamUser = async (user, dispatch, axiosJWT, userId, examId) => {
    dispatch(getDoExamStart());
    try {
        const res = await axiosJWT.get(`/api/exam-assignments/${examId}/${userId}`, {
            headers: { token: `Bearer ${user}` },
        });
        await dispatch(getDoExamSuccess(res.data));
    }
    catch (error) {
        if (error.response && error.response.data && error.response.data.message !== "") {
            dispatch(getDoExamFailed());
        }
    }
}
// Nộp bài thi Online 
export const submitExamUser = async (accessToken, dispatch, axiosJWT, userId, examId, data, successCallback, failedCallback) => {
    dispatch(submitEmxamOnlineStart());
    try {
        await axiosJWT.post(`/api/exam-assignments/${examId}/${userId}`, data, {
            headers: { token: `Bearer ${accessToken}` },
        });
        dispatch(submitEmxamOnlineSuccess());
        await successCallback();
    }
    catch (error) {
        console.error("Submit exam failed:", error.response?.data || error.message);
        dispatch(submitEmxamOnlineFailed());
        failedCallback();
    }
}
// Tạo đề thi Online
export const createExamOnline = async (dispatch, accessToken, newExam, axiosJWT, successCallback, errCallback) => {
    dispatch(createEmxamOnlineStart());
    try {
        await axiosJWT.post("/api/exam-assignments", newExam, {
            headers: { token: `Bearer ${accessToken}` },
        });

        dispatch(createEmxamOnlineSuccess());
        await successCallback();
    } catch (error) {
        if (error.response && error.response.data && error.response.data.message !== "") {
            await errCallback();
            dispatch(createEmxamOnlineFailed(error));
        }
    }
}
// Lấy thông tin đề thi theo ID đề thi 
export const getExamByIdUser = async (user, dispatch, axiosJWT, examId) => {
    dispatch(getExamByIdStart());
    try {
        const res = await axiosJWT.get(`/api/exam-assignments/${examId}`, {
            headers: { token: `Bearer ${user}` },
        });
        await dispatch(getExamByIdSuccess(res.data));
    }
    catch (error) {
        if (error.response && error.response.data && error.response.data.message !== "") {
            dispatch(getExamByIdFailed());
        }
    }
}